import { api } from 'utility';
import { fileDownloader } from 'utility/util';
import {
  getReportServiceCallUrl,
  getExportServiceCallReportUrl,
  getReportMyServiceCallUrl,
  getExportMyServiceCallReportUrl,
  getReportWebServiceUrl,
} from 'URLs';
class ServiceCallServices {
  async reportServiceCall(param, dataParams) {
    return api.post(getReportServiceCallUrl(param.size, param.page), {
      ...dataParams,
    });
  }

  async reportServiceCallExport(param, dataParams, type) {
    return fileDownloader(
      'POST',
      getExportServiceCallReportUrl(type),
      param,
      dataParams,
      null,
      type,
    );
  }

  async reportMyServiceCall(param, dataParams) {
    return api.post(getReportMyServiceCallUrl(param.size, param.page), {
      ...dataParams,
    });
  }

  async reportMyServiceCallExport(params, dataParams, type, onError) {
    return fileDownloader(
      'POST',
      getExportMyServiceCallReportUrl(type),
      params,
      dataParams,
      null,
      type,
      null,
      onError,
    );
  }

  async reportWebService(param, dataParams) {
    return api.post(getReportWebServiceUrl(param.size, param.page), {
      ...dataParams,
    });
  }
}

export default new ServiceCallServices();
